import { definePreset, palette } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const abcPreset = definePreset(Aura, {
  semantic: {
    primary: palette('#1d569d'),
  },
  components: {
    datatable: {
      headerCell: {
        background: '{gray.100}',
      },
      extend: {
        tableContainerBorderRadius: '12px',
      },
      css: ({ dt }) => `
        .p-datatable-table-container {
          border-radius: ${dt('datatable.table.container.border.radius')};
          overflow: hidden;
          border: solid 1px var(--color-border)
        }
        .p-datatable-tbody > tr:last-child > td {
          border-bottom: none;
        }
      `,
    },
  },
});
